import { executionIntervalValues } from '#/modules/wo-template/utils/constants';

export const calculateTemplateDueDate = (executionInterval?: string | null): string | null => {
  if (!executionInterval || executionInterval === executionIntervalValues.na) {
    return null;
  }

  const now = new Date();
  const currentYMD = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(
    now.getDate(),
  ).padStart(2, '0')}`;
  const nextDate = new Date(currentYMD);

  switch (executionInterval) {
    case executionIntervalValues.daily:
      nextDate.setDate(nextDate.getDate() + 1);
      break;
    case executionIntervalValues.weekly:
      nextDate.setDate(nextDate.getDate() + 7);
      break;
    case executionIntervalValues.monthly:
      nextDate.setMonth(nextDate.getMonth() + 1);
      break;
    case executionIntervalValues.quarter:
      nextDate.setMonth(nextDate.getMonth() + 3);
      break;
    case executionIntervalValues.semiAnnual:
      nextDate.setMonth(nextDate.getMonth() + 6);
      break;
    case executionIntervalValues.threeQuarter:
      nextDate.setMonth(nextDate.getMonth() + 9);
      break;
    case executionIntervalValues.annual:
      nextDate.setMonth(nextDate.getMonth() + 12);
      break;
    default:
      return null;
  }

  return nextDate.toISOString().split('T')[0];
};
